var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAppDeploymentSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9361 28.768C61.4401 34.928 61.5042 44.952 51.0641 51.112C48.0401 52.896 44.2801 54.24 40.2161 55C38.8721 55.256 37.4641 55.024 36.5121 54.472C36.1361 54.272 35.8241 53.968 35.6081 53.6C34.9921 52.472 36.0401 51.264 37.9761 50.904C40.9681 50.344 43.6401 49.392 45.8641 48.072C53.4721 43.584 53.4241 36.288 45.7761 31.808C38.1281 27.328 25.7201 27.32 18.1281 31.808C12.4641 35.152 10.8641 40.304 14.1601 44.632C14.9841 45.712 14.1601 46.984 12.3281 47.472C10.9041 47.84 9.29614 47.64 8.25615 47.032C7.96815 46.864 7.71215 46.648 7.50415 46.384C2.96815 40.448 5.16015 33.376 12.9441 28.776C23.3921 22.608 40.4321 22.608 50.9441 28.776L50.9361 28.768Z",
    fill: "url(#paint0_linear_5665_1167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0241 49.304L16.2881 40.264L32.0241 31.176L47.7041 40.264L32.0241 49.304Z",
    fill: "url(#paint1_linear_5665_1167)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1362 11.416L32.0322 6.896L39.8722 11.416L32.0322 15.936L24.1362 11.416Z",
    fill: "url(#paint2_linear_5665_1167)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0239 15.936V34.12L39.8639 29.544V11.416L32.0239 15.936Z",
    fill: "url(#paint3_linear_5665_1167)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0239 15.936L24.1279 11.416V29.544L32.0239 34.12V15.936Z",
    fill: "url(#paint4_linear_5665_1167)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1362 11.416L32.0322 15.936",
    stroke: "#DCDCDC",
    strokeWidth: 0.74
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0239 15.936L39.8639 11.416L47.7039 15.936L39.8639 20.512L32.0239 15.936Z",
    fill: "url(#paint5_linear_5665_1167)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8643 20.504V38.632L47.7043 34.112V15.936L39.8643 20.512V20.504Z",
    fill: "url(#paint6_linear_5665_1167)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8639 20.504L32.0239 15.928V34.112L39.8639 38.632V20.504Z",
    fill: "url(#paint7_linear_5665_1167)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2959 15.936L24.1359 11.416L32.0319 15.936L24.1359 20.512L16.2959 15.936Z",
    fill: "url(#paint8_linear_5665_1167)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1362 20.504V38.632L32.0322 34.112V15.936L24.1362 20.512V20.504Z",
    fill: "url(#paint9_linear_5665_1167)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1359 20.504L16.2959 15.928V34.112L24.1359 38.632V20.504Z",
    fill: "url(#paint10_linear_5665_1167)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1362 29.544L32.0322 25.024L39.8722 29.544L32.0322 34.12L24.1362 29.544Z",
    fill: "url(#paint11_linear_5665_1167)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0239 34.12V43.16L39.8639 38.64V29.552L32.0239 34.128V34.12Z",
    fill: "url(#paint12_linear_5665_1167)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0239 34.1199L24.1279 29.5439V38.6319L32.0239 43.1519V34.1119V34.1199Z",
    fill: "url(#paint13_linear_5665_1167)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2959 15.936L24.1359 20.512",
    stroke: "white",
    strokeWidth: 0.44
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0239 15.936L39.8639 20.512",
    stroke: "white",
    strokeWidth: 0.44
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1362 29.5439L32.0322 34.1199",
    stroke: "#DCDCDC",
    strokeWidth: 0.74
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5665_1167",
    x1: 40.5041,
    y1: 20.96,
    x2: 23.8001,
    y2: 58.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5665_1167",
    x1: 26.1201,
    y1: 50.464,
    x2: 37.8961,
    y2: 30.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5665_1167",
    x1: 29.0882,
    y1: 16.52,
    x2: 34.9122,
    y2: 6.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5665_1167",
    x1: 32.0079,
    y1: 22.768,
    x2: 39.8639,
    y2: 22.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5665_1167",
    x1: 24.1519,
    y1: 22.768,
    x2: 32.0079,
    y2: 22.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5665_1167",
    x1: 39.1519,
    y1: 19.6,
    x2: 40.5679,
    y2: 12.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5665_1167",
    x1: 39.8643,
    y1: 27.288,
    x2: 47.7203,
    y2: 27.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5665_1167",
    x1: 32.0159,
    y1: 27.288,
    x2: 39.8719,
    y2: 27.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5665_1167",
    x1: 23.4559,
    y1: 19.6,
    x2: 24.8559,
    y2: 12.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5665_1167",
    x1: 24.1522,
    y1: -94.4,
    x2: 32.0002,
    y2: -94.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5665_1167",
    x1: 16.2959,
    y1: -94.4,
    x2: 24.1519,
    y2: -94.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5665_1167",
    x1: 29.0402,
    y1: 34.656,
    x2: 34.9442,
    y2: 24.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5665_1167",
    x1: 32.0159,
    y1: 36.352,
    x2: 39.8719,
    y2: 36.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5665_1167",
    x1: 24.1599,
    y1: 36.3519,
    x2: 32.0159,
    y2: 36.3519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAppDeploymentSmall);
export default __webpack_public_path__ + "static/media/no_appDeployment_small.c9c47b6fd60e2dd69e57edef2c2e8649.svg";
export { ForwardRef as ReactComponent };